import http from '../../plugins/axios';

export default {

    /** 获取所有支持币种 */
    getAllSupportCoins(){
        return http.get({
            url: '/admin/coin/all'
        });
    },

    configWalletCoins(data) {
        return http.post({
            url : '/admin/transfer/walletCoinSet',
            data
        })
    },

    configInnerCoins(data) {
        return http.post({
            url : '/admin/transfer/innerCoinSet',
            data
        })
    },

    configAirDropCoins(data) {
        return http.post({
            url : '/admin/sys/setting/airdrop/changeCoins',
            data
        })
    },

    getWalletSupCoin(){
        return http.get({
            url: '/admin/transfer/walletCoin'
        });
    },

    getInnerSupCoin() {
        return http.get({
            url: '/admin/transfer/innerCoin'
        });
    },

    getAirDropSupCoin() {
        return http.get({
            url: '/admin/sys/setting/airdrop/coins'
        });
    },

    queryConfigList(data){
        return http.get({
            url: '/admin/cold/wallet/config/list',
            data
        });
    },

    configToColdWallet(data) {
        return http.post({
            url: '/admin/cold/wallet/config/save',
            data,
            dataType: 'form'
        })
    },

    getHeadColdSwitch(){
        return http.get({
            url: '/admin/cold/wallet/switch',
        })
    },

    saveHeadColdSwitch(data) {
        return http.post({
            url: '/admin/cold/wallet/switch',
            data,
            dataType: 'form'
        })
    },

    setCodeRunningSwitch(data) {
        return http.post({
            url: '/admin/cold/wallet/running/switch/update',
            data,
            dataType: 'form'
        })
    },

    deleteConfig(data) {
        return http.post({
            url: '/admin/cold/wallet/config/remove',
            data,
            dataType: 'form'
        })
    }

}
